import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import logo from "../../asset/CODEHOUZE-1.jpg";

const socialLinks = [
  { href: "https://twitter.com/codehouze", icon: faTwitter, label: "Twitter" },
  { href: "https://www.linkedin.com/in/codehouze/", icon: faLinkedin, label: "LinkedIn" },
  { href: "https://www.github.com/codehouze/", icon: faGithub, label: "GitHub" },
];

const CodehouzeFooter = () => {
  return (
    <footer className="relative bg-gray-900">
      <div className="h-px bg-gradient-to-r from-transparent via-codehouzeOrange/40 to-transparent" />
      <div className="mx-auto max-w-6xl px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="bg-white rounded-md p-1 flex items-center justify-center">
              <img src={logo} alt="Codehouze" className="h-6 w-6 object-contain" />
            </span>
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Codehouze Technology Solutions.
            </p>
          </div>
          <div className="flex items-center gap-5">
            {socialLinks.map(({ href, icon, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="text-gray-500 hover:text-codehouzeOrange transition-colors duration-200"
              >
                <FontAwesomeIcon icon={icon} className="text-xl" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CodehouzeFooter;
